import Question from "./Question";

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Module from "./Popup";

import { getDecrypt, getQuestionFM } from "../../util/resources";

import { ProgressBar } from "@adeccoux/tag-ds";
import SesHeader from "../header";
import "./checkmark.scss";
import Completed from "./Completed";
import CounterTimer from "./CounterTimer";

let sessionId = "",
  testId = "";
let content = "";
function TestTakerForFM() {
  let [testName, setTestName] = useState("Focus&Multitasking");
  let [BatchFinished, setBatchFinished] = useState(false);
  let totalQuestions = 0;
  let questionsData = [];
  const [threshold, setThreshold] = useState();
  let numberOfMeters = 0;
  let sessionId = window.sessionStorage.getItem("sessionId");
  let testId = window.sessionStorage.getItem("testId");
  let [isMain, setIsMain] = useState(false);

  let location = useLocation();
  const testPhrases = location.state.user.siteConfig.phrases;
  let [page, setPage] = useState(0);
  let currQuestNo = useRef(0);
  let [currQuestNoAtBatch, setCurrQuestNoAtBatch] = useState(0);
  let [batch, setBatch] = useState(1);
  let [redirectUrl, setRedirectUrl] = useState("");
  let [questions, setQuestions] = useState([]);
  let [meterRefills, setMeterRefill] = useState([]);
  let [loading, setLoading] = useState(true);
  let callbackUrl = window.sessionStorage.getItem("callbackUrl");
  const [showcounter, setCounterCounter] = useState(true);
  const [isOffline, setOffline] = useState(false);
  let [isComplete, setComplete] = useState(false);
  const afterMeterReset = useRef(false);

  const [userFeedback, setUserFeedback] = useState({
    show: false,
    notiftype: 0,
    header: "",
    body: "",
    shouldMoveToNextQuestion: false,
  });

  useEffect(() => {
    if (location.state.data.status.id == 2) {
      window.location.replace(callbackUrl);
    }
    if (
        location.state.isExample != undefined && 
        !location.state.isExample
    ) {
      setTestName(location.state.data.name);
      numberOfMeters = location.state.data.numberOfMeterRefill;
      totalQuestions = 
        location.state.data.questionsCount - numberOfMeters;
      setThreshold(location.state.data.threshold);
      loadMainQuestion("" + 0);
    } else if (
      location.state.data != undefined &&
      location.state.data.testExampleName
    ) {
      setTestName(location.state.data.testExampleName);
      var questions = location.state.data.testExample;
      setThreshold(location.state.data.thresholdExample);
      numberOfMeters = location.state.data.numberOfMeterRefillExample;
      totalQuestions = questions.length - numberOfMeters;
      populateQuestion(questions);
    }
    if (window.sessionStorage.getItem("content")) {
      content = window.sessionStorage.getItem("content");
    } else {
      content = window.location.pathname.substring(21).toString();
      window.sessionStorage.setItem("content", content);
    }
    if (window.sessionStorage.getItem("sessionId")) {
      sessionId = window.sessionStorage.getItem("sessionId");
      testId = window.sessionStorage.getItem("testId");
    } else {
      getDecrypt(content).then((response) => {
        let arr = response.data.response.toString().split(",");
        sessionId = arr[0];
        testId = arr[1];
        window.sessionStorage.setItem("sessionId", sessionId);
        window.sessionStorage.setItem("testId", testId);
      });
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("firstLoadDone") === null) {
      localStorage.setItem("firstLoadDone", 1);
      console.log("This is the initial load");
    } else {
      console.log("This is a page refresh");
      localStorage.removeItem("firstLoadDone");
      window.location.replace(callbackUrl);
    }
  }, []);

  let [totalQuest, setTotalQuest] = useState(0);

  const populateQuestion = function (questions) {
    var unattempted = 0;
    var startBatch = 0;
    var batchStarted = false;
    for (var q = 0; q < questions.length; q++) {
      if (
            questions[q].questions[0].userAnswer == null || 
            q < numberOfMeters
        ) {
        var bat = questions[q].questions[0].skill_level;
        if (bat > 0 && !batchStarted) {
          startBatch = bat;
          batchStarted = true;
        }
        if (questionsData[bat] === undefined) {
          questionsData[bat] = [];
          questionsData[bat][0] = questions[q].questions[0];
        } else {
          questionsData[bat][questionsData[bat].length] =
            questions[q].questions[0];
        }
        if (!q < numberOfMeters) {
          unattempted += 1;
        }
      }
    }
    var meters = [];
    if (questionsData[0]) {
      for (var i = 0; i < questionsData[0].length; i++) {
        meters.push(questionsData[0][i]);
      }
    }

    if (startBatch == 0) {
      window.location.replace(callbackUrl);
    }
    setQuestions(questionsData);
    setCurrentQuestion(questionsData[startBatch][0]);
    setTotalQuest(totalQuestions);
    currQuestNo.current = totalQuestions - (unattempted - meters.length);
    setBatch(startBatch);
    setLoading(false);
    setMeterRefill(meters);
  };

  let loadMainQuestion = function (page) {
    var respData = [];
    setTotalQuest(totalQuestions);
    setIsMain(true);
    getQuestionFM(testId, sessionId, page).then((response) => {
      respData = response.data;
      populateQuestion(respData);
    });
  };

  let [currentQuestion, setCurrentQuestion] = useState(null);
  let finished = false;
  const nextQuestion = () => {
    currQuestNo.current += 1;
    if (currQuestNo.current == totalQuest) {
      setRedirectUrl(`/instructions/${content}`);
      setCurrentQuestion(null);
      if (batch == questions.length - 1) {
        setBatch(batch + 1);
        setBatchFinished(true);
        finished = true;
      }
    }
    if (!finished) {
      if (currQuestNoAtBatch === questions[batch].length - 1) {
        setBatch(batch + 1);
        setCurrQuestNoAtBatch(0);
        setCurrentQuestion(questions[batch + 1][0]);
        setBatchFinished(true);
      } else {
        setCurrentQuestion(questions[batch][currQuestNoAtBatch + 1]);
        setCurrQuestNoAtBatch((prev) => prev + 1);
      }
    }
  };

  const handelCounterScreen = () => {
    setCounterCounter(false);
  };

  const handleClose = () => {
    window.location.reload();
  };

  let showBreather = (flag) => setBatchFinished(flag);
  let moveNextQuest = () => nextQuestion();

  const handleUserFeedback = (e) => {
    e.stopPropagation();
    setUserFeedback((prev) => ({ ...prev, show: false }));
    if (userFeedback.meterReset) {
      afterMeterReset.current = true;
    }
    if (currQuestNo.current === totalQuest - 1) {
      moveNextQuest();
    }
  };

  const enableCounterScreen = () => {
    showBreather(false);
    setCounterCounter(true);
  };


  if (loading) {
    return <h1>Loading..</h1>;
  }

  return (
    <>
      <div className="tt37 g-container flex_col g2 pt0_mobile g2_mobile">
        <SesHeader clientCobranding={location.state.cobrandingLink} />
        <div className="input-grey grey-base ui-view-container card-container translate-horizontal-transition">
          {showcounter && !isOffline ? (
            <CounterTimer handelCounterScreen={handelCounterScreen} />
          ) : null}
          {isOffline && (
            <Module.MeterPositiveNotif
              header=""
              body={testPhrases[26000010]}
              notifType="2"
              deActivate={handleClose}
            />
          )}
          {userFeedback.show && !isOffline && (
            <Module.MeterPositiveNotif
              header={userFeedback.header}
              body={userFeedback.body}
              notifType={userFeedback.notiftype}
              deActivate={handleUserFeedback}
            />
          )}
          {(isComplete && isMain) ||
          (BatchFinished && !userFeedback.show && !isOffline) ? (
            <Completed
              redirect={callbackUrl}
              totalBatch={questions.length - 1}
              completedBatch={batch - 1}
              enableCounterScreen={enableCounterScreen}
              completedTest={isComplete}
            />
          ) : null}
          <div className="container-fluid container-page test container">
            <div className="panel panel-desktop-wrapper card-wrapper">
              <div className="panel panel-default question question-body-ui-view card-content question-class g2">
                <div className="flex_col g2">
                    <div className="test-info-bar card-header">
                    <ProgressBar
                        showSteps
                        helper={{
                        left:
                            currQuestNo.current +
                            1 +
                            "/" +
                            totalQuest +
                            " " +
                            testPhrases?.["13106"],
                        }}
                        step={currQuestNo.current + 1}
                        steps={totalQuest}
                        title={testPhrases["14798"]}
                    />
                    </div>
                    <div className="flex_col">
                    <h3>
                        {location.state.warmUp
                        ? location.state.test.testExampleName
                        : location.state.test.name}
                    </h3>
                    </div>
                </div>
                <Question
                  isExample={!isMain}
                  threshold={threshold}
                  meterRefills={meterRefills}
                  currQuestNo={currQuestNo}
                  totalQuest={totalQuest}
                  totalBatch={questions.length - 1}
                  currentBatch={batch}
                  batchFinishes={BatchFinished}
                  dataQuestion={currentQuestion}
                  redirectTo={redirectUrl}
                  moveNextQuest={moveNextQuest}
                  showcounter={showcounter}
                  setOffline={setOffline}
                  userFeedback={userFeedback}
                  setUserFeedback={setUserFeedback}
                  handleUserFeedback={handleUserFeedback}
                  isComplete={isComplete}
                  setComplete={setComplete}
                  afterMeterReset={afterMeterReset}
                  finished={finished}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TestTakerForFM;
